import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import TableTemplate from "../../../../../Components/Table/TableTemplate";
import { SCHOOLS_AND_USER_STATS_ENDPOINT } from "../../../../../Constants/Endpoints";
import { exportSchoolAndUserStatsCsvRequest } from "../../../../../Backend/SchoolsRequests";

import {
  displayDateTime,
  parseDateFromUtc,
} from "../../../../../Helpers/utils/utils";

import "./StatsOverviewPage.scss";

export function StatsOverviewPage() {
  const tableTemplateRef = useRef(null);
  const [t] = useTranslation();

  const [columns] = useState([
    { name: "school.schoolNumber", headerCaption: t("SchoolNumber"), canSort: false, canFilter: false, canEdit: false, },
    { name: "school.name", headerCaption: t("Name"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotal.totalBooks", headerCaption: t("TotalBooks"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotal.totalInitialBooks", headerCaption: t("Initial"), canSort: false, canFilter: false, canEdit: false, },
    //{ name: "schoolTotal.percentInitialBooks", headerCaption: t("Initial"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotal.totalReturnedBooks", headerCaption: t("Returned"), canSort: false, canFilter: false, canEdit: false, },
    //{ name: "schoolTotal.percentReturnedBooks", headerCaption: t("Returned"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotal.totalKeepedBooks", headerCaption: t("Keeped"), canSort: false, canFilter: false, canEdit: false, },
    //{ name: "schoolTotal.percentKeepedBooks", headerCaption: t("percentKeepedBooks"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotal.totalReportedBooks", headerCaption: t("Reported"), canSort: false, canFilter: false, canEdit: false, },
    //{ name: "schoolTotal.percentReportedBooks", headerCaption: t("percentReportedBooks"), canSort: false, canFilter: false, canEdit: false, },
    //{ name: "schoolTotal.percentReportedByNeverRecivedBooks", headerCaption: t("percentReportedByNeverRecivedBooks"), canSort: false, canFilter: false, canEdit: false, },
    //{ name: "schoolTotal.percentReportedByGaveToTeacherBooks", headerCaption: t("percentReportedByGaveToTeacherBooks"), canSort: false, canFilter: false, canEdit: false, },
    //{ name: "schoolTotal.percentReportedByAlreadyTurnedBooks", headerCaption: t("percentReportedByAlreadyTurnedBooks"), canSort: false, canFilter: false, canEdit: false, },
    //{ name: "schoolTotal.percentReportedByLostBooks", headerCaption: t("percentReportedByLostBooks"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotalUser.users", headerCaption: t("TotalStudents"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotalUser.userLogged", headerCaption: t("Logged"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotalUser.userNotLogged", headerCaption: t("NotLogged"), canSort: false, canFilter: false, canEdit: false, },
    //{ name: "schoolTotalUser.userWithAllInitial", headerCaption: t("userWithAllInitial"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotalUser.userWithSomeNotInitial", headerCaption: t("userWithSomeNotInitial"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotalUser.userWithAllNotInitial", headerCaption: t("userWithAllNotInitial"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotalUser.userWithSomeKeeped", headerCaption: t("userWithSomeKeeped"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotalUser.userWithSomeReported", headerCaption: t("userWithSomeReported"), canSort: false, canFilter: false, canEdit: false, },
    { name: "schoolTotalUser.date", headerCaption: t("LastUpdateDateTime"), canSort: false, canFilter: false, canEdit: false, caption: (x) => displayDateTime(parseDateFromUtc(x.schoolTotalUser.date)), },
  ]);

  
  const exportSchoolStats = async () => {
    await exportSchoolAndUserStatsCsvRequest("SchoolStats");
  }

  return (
    <div className="stats-overview-page">
      <TableTemplate
        ref={tableTemplateRef}
        title={t("StatsOverview")}
        endpoint={SCHOOLS_AND_USER_STATS_ENDPOINT}
        columns={columns}
        uniqueId="school.id"
        paginator={false}
        customButtons={[
          {
            name: t("ExportSchoolStats"),
            action: () => exportSchoolStats(),
          },
        ]}
      />
    </div>
  );
}
